import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../system/client/src/services/api';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post('auth/forgot-password', { email });
        } catch (error) {
            // Deliberately swallow errors — we never reveal whether an
            // address exists. The success state below is always shown.
            console.error('Forgot password error:', error);
        } finally {
            setLoading(false);
            setSent(true);
        }
    };

    if (sent) {
        return (
            <section className="fs-auth-card">
                <div className="fs-auth-head">
                    <span className="kicker">Check your inbox</span>
                    <h1>Reset link sent.</h1>
                    <p>
                        If that email exists, we've sent a reset link — check
                        your inbox.
                    </p>
                </div>

                <p className="fs-auth-switch">
                    <Link to="/login">Back to sign in.</Link>
                </p>
            </section>
        );
    }

    return (
        <section className="fs-auth-card">
            <div className="fs-auth-head">
                <span className="kicker">Reset password</span>
                <h1>Forgot your password?</h1>
                <p>Enter your email and we'll send you a reset link.</p>
            </div>

            <form onSubmit={onSubmit} noValidate>
                <div className="form-field">
                    <label htmlFor="email">Email</label>
                    <input
                        id="email"
                        type="email"
                        autoComplete="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="you@company.com"
                    />
                </div>

                <div className="fs-auth-actions">
                    <button
                        type="submit"
                        className="btn btn-primary btn-block"
                        disabled={loading}
                    >
                        {loading ? 'Sending…' : (
                            <>Send reset link <span className="arrow">→</span></>
                        )}
                    </button>
                </div>
            </form>

            <p className="fs-auth-switch">
                <Link to="/login">Back to sign in.</Link>
            </p>
        </section>
    );
};

export default ForgotPasswordPage;
